import React from 'react';

/**
 * Shared PageHeader component
 * Guarantees every page explains itself with a visible <h1>, concise description,
 * and optional actions slot. Profession-neutral, RTL-ready, accessible.
 */
export default function PageHeader({
  title,
  description,
  badge,
  actions,
  className = '',
}) {
  return (
    <header className={`mb-6 sm:mb-8 flex flex-col md:flex-row md:items-end justify-between gap-4 ${className}`}>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2.5 flex-wrap">
          <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-ink dark:text-white font-ui">
            {title}
          </h1>
          {badge && (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-forest-faint text-forest dark:bg-forest/20 dark:text-forest-ondark border border-forest/20">
              {badge}
            </span>
          )}
        </div>
        {description && (
          <p className="mt-1.5 text-xs sm:text-sm text-ink-muted dark:text-ink-muted-dark max-w-3xl leading-relaxed">
            {description}
          </p>
        )}
      </div>

      {actions && (
        <div className="flex items-center gap-2 sm:gap-3 flex-wrap shrink-0">
          {actions}
        </div>
      )}
    </header>
  );
}
